import { css, SerializedStyles } from "@emotion/react";
import styled from "@emotion/styled";
import { EmotionTheme } from "src/domains/layouts/config/emotionTheme";
import { DefaultComponentVariantType } from "src/domains/layouts/config/features/types";
import { withConfig } from "src/withConfig";

interface PromotedEventsWrapperPropsType {
    variant: DefaultComponentVariantType | null;
    topMargin: boolean;
}

const setPromotedEventsWrapper = (variant: DefaultComponentVariantType | null, topMargin: boolean): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            margin-top: ${topMargin ? '8px' : '0'};
        `;
    }
    return css``;
};

export const PromotedEventsWrapper = styled('div', { label: 'PromotedEventsWrapper' })<PromotedEventsWrapperPropsType>`
    ${({ variant, topMargin }): SerializedStyles => setPromotedEventsWrapper(variant, topMargin)}
`;

const setPromotedSportsWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            @media ${theme.star.mediaQuery.tablet} {
                margin: 0 8px;
                border-radius: 0 0 8px 8px;
                overflow: hidden;
            }
        `;
    }
    if (variant === DefaultComponentVariantType.TERTIARY) {
        return css`
            background: ${theme.star.unified.eventsGroupedFiltersColors.bgColorSecondary};
        `;
    }
    return css``;
};

interface PromotedSportsWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

export const PromotedSportsWrapper = withConfig(theme => styled('div', { label: 'PromotedSportsWrapper' })<PromotedSportsWrapperPropsType>`
    ${({ variant }): SerializedStyles => setPromotedSportsWrapper(variant, theme)}
`);
